import React from 'react';
import { Select } from '@domain-group/fe-blueprint-ui/select';
import { SortIcon } from '@domain-group/fe-co-icon';
import {
  DEFAULT_SORT_LABEL,
  SORT_OPTIONS_AGENCIES_2026,
  SORT_OPTIONS_AGENTS_2026,
} from '../search-filter-bar/enums';
import * as styles from './sort-by-select.style';

interface SortBySelectProps {
  isAgency: boolean;
  selectedSortBy: string;
  setSortBy: (sortBy: string) => void;
}

const renderSelectedOption = (selectedItem: { label: string } | null) => (
  <>
    <span css={styles.mobileOnly}>Sort</span>
    <span css={styles.tabletAndUp}>{selectedItem?.label}</span>
  </>
);

const SortBySelect = ({
  isAgency,
  selectedSortBy,
  setSortBy,
}: SortBySelectProps): JSX.Element => {
  const options = isAgency
    ? SORT_OPTIONS_AGENCIES_2026
    : SORT_OPTIONS_AGENTS_2026;

  return (
    <div css={styles.sortBy} data-testid="sort-by-select">
      <div css={styles.select}>
        <Select
          instanceId="sort-by-select"
          label="Sort by"
          labelHidden
          appearance="separated"
          hideChevron
          renderSelectedOption={renderSelectedOption}
          icon={<SortIcon size="small" />}
          nowrap
          alignBody="right"
          options={options}
          value={selectedSortBy}
          placeholder={DEFAULT_SORT_LABEL}
          onChange={(selected) => {
            if (selected) {
              setSortBy(selected.value);
            }
          }}
        />
      </div>
    </div>
  );
};

export default SortBySelect;
